module.exports = __webpack_public_path__ + "img/softinya-prop-6.609d52d0.webp";